module.exports = __webpack_public_path__ + "fonts/Lato-Light.90301aa0.woff";